import{REPLAY_PLUGIN_ID as n}from"../constants";export var isReplayPlugin=function(o){var r;return(null===(r=o.getId)||void 0===r?void 0:r.call(o))===n};